<script>
import { mapActions, mapState } from "pinia";
import { useDatalayerStore } from "@/store/datalayer";
import { useMagasinStore } from "@/store/magasin";
import { useContextStore } from "@/store/context";

export default {
  computed: {
    ...mapState(useContextStore, ["layout"]),
    component() {
      return defineAsyncComponent(
        lazyComponents[`/components/pages/page-not-found/${this.layout}.vue`]
      );
    }
  },
  methods: {
    ...mapActions(useDatalayerStore, {
      setStoreLocatorContext: "setStoreLocatorContext"
    }),
    ...mapActions(useMagasinStore, {
      displayOrCloseStoreLocatorPopin: "displayOrCloseStoreLocatorPopin"
    }),
    async showShops() {
      navigateToInternal("/");
      this.setStoreLocatorContext("page 404");
      this.displayOrCloseStoreLocatorPopin();
    }
  }
};
</script>

<template>
  <component
    :is="component"
    @showShops="showShops"
  />
</template>
